import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { Link } from 'react-router-dom';

// Components
import EventDetails from './EventDetails';
import EventMeta from './EventMeta';

import styles from './PublicEvents.module.postcss';
import useMapLink from '../../../hooks/useMapLink';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.tz.setDefault('America/Los_Angeles');

function TruckEvent({ event, forCalendar = false }) {
  const mapLink = useMapLink(event.location);

  return (
    <div className={cn(styles.PublicEvent, { [styles.PublicEvent__calendar]: forCalendar })}>

      <div className={styles.PublicEvent_imgContainer}>
        <div className={styles.PublicEvent_img}>
          { event.static_map_img &&
            <img src={event.static_map_img} alt={`${event.display_name} location`} />
          }
        </div>
        <a href={mapLink} target='_blank' rel='noopener noreferrer'>
          <div className={styles.PublicEvent_directions}>Get directions</div>
        </a>
      </div>

      <div className={styles.PublicEvent_content}>
        { event.location &&
          <h3>
            <Link to={`/schedule/${event.location.slug}`}>{event.display_name}</Link>
          </h3>
        }
        { !event.location &&
          <h3>{event.display_name}</h3>
        }

        <EventDetails
          event={event}
          address={event.address}
        />

        { event.location &&
          <Link to={`/schedule/${event.location.slug}`} className={styles.PublicEvent_allTrucksLink}>
            See all trucks at this location
          </Link>
        }

        <EventMeta event={event} location={event.location} />
      </div>
    </div>
  );
}

TruckEvent.propTypes = {
  event: PropTypes.object.isRequired,
};

export default TruckEvent;
